import { render, staticRenderFns } from "./CheckWork.vue?vue&type=template&id=37dc2b42&"
import script from "./CheckWork.vue?vue&type=script&lang=js&"
export * from "./CheckWork.vue?vue&type=script&lang=js&"
import style0 from "./CheckWork.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports